export enum APIGravityUnits {
  Grades,
  GramsCubicCentimeter,
}
